<template>
<div class="flex w-full vx-row no-gutter justify-center">
   <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    
    <vx-card class="study-card">
      <div class="lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base text-center">
        <h1 class="mb-4 text-primary sentence">수고하셨습니다. 유닛 학습이 마무리 되었습니다.</h1>
        <p class="text-primary mb-4">{{sourceContent.stepName}}</p>
        <vs-button @click="onBack">학습완료</vs-button>
      </div>
    </vx-card>
  </div>  
  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'

export default {
  mixins: [StudyMenuMixin],
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
   
  },
  methods: {
    onBack () {
      this.$router.push('/main')
    }
  },
  created () {
  }
}

</script>

